import AuthLayout from '@/views/AuthLayout.vue';
import ViewStudentsInTalentPool from '@/views/dashboard/client/talentPool/ViewStudentsInTalentPool.vue';

export default {
	path: '/',
	component: AuthLayout,
	name: 'client-talent-pool',
	children: [
		{
			path: 'talent-pools/:id',
			name: 'talent-pools-students',
			component: ViewStudentsInTalentPool,
			meta: {
				accessTalentPool: true,

				props: true,
			},
		},
	],
};
